/* eslint-disable no-unused-vars */
// import Connectors from '../../Charger/Conectors';
import CorporateChargingSessionsGrid from '../CorporateChargingSessionsGrid';
// import ChargingSessions from '../../Charger/ChargingSessions';
// import OCPPLogs from '../../Charger/OCPPLogs';
// import OCPPConnectionHistory from '../../Charger/OCPPConnectionsHistory';
// import ChargerControls from '../../Charger/ChargerControls';
import { useState } from 'react';
import {
  Button,
  Typography,
  Tabs,
  Modal,
  // Col,
  // Divider,
  Select,
  Spin,
  message,
} from 'antd';
import { BiReset } from 'react-icons/bi';
import { Row, Col, Card } from 'reactstrap';
import { find, get } from 'lodash-es';
import QRCode from 'qrcode.react';
import { DownloadOutlined, ClearOutlined } from '@ant-design/icons';
import ChargerDetailCard from '../ChargerDetailCard';
import CorporateChargingQueue from '../CorporateChargingQueue';
import Connectors from 'components/Reusable/ConnectorsGrid';
import {
  useResetChargerMutation,
  useClearCacheMutation,
} from 'utils/queries/corporateChargers';

const { Title, Text } = Typography;

const { Option } = Select;

const { TabPane } = Tabs;

export default function CorporateChargerDetails({
  corporateId,
  cp,
  cpid,
  isChargerLoading,
}) {
  const [sessionsLogsSectionActiveKey, setSessionsLogsSectionActivekey] =
    useState('1');

  const [ocppLogsRefreshInterval, setOcppLogsRefreshInterval] = useState(3000);
  const [resetChargerModalOpen, setResetChargermodalOpen] = useState(false);

  const downloadQR = () => {
    const canvas = document.getElementById('qr-code');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${getChargerIdForQR()}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const getChargerIdForQR = () => {
    return cp?.hasOwnProperty('JP_CORPORATE_CHARGER.CHARGER')
      ? get(cp, 'JP_CORPORATE_CHARGER.CHARGER')
      : cpid;
  };

  const Divider = () => (
    <div style={{ border: '1px solid #F5F8FA', margin: 5 }}></div>
  );

  function ResetChargerModal({ cpid, isModalVisible, changeIsModalVisible }) {
    const initiateResetCharger = useResetChargerMutation();
    const [selectedType, setSelectedType] = useState('');
    async function resetCharger(type) {
      try {
        const result = await initiateResetCharger
          .mutateAsync({
            ChargerId: cpid,
            type,
          })
          .then((res) => res.data);
        message.success(result?.status);
      } catch (error) {
        message.error(`Something went wrong: ${error?.message}`);
      }
    }

    return (
      <Modal
        title="Reset Charger"
        visible={isModalVisible}
        // onOk={handleOk}
        onCancel={() => changeIsModalVisible(false)}
        footer={null}
      >
        <Row>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <Button
              type="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                setSelectedType('Hard');
                resetCharger('Hard');
              }}
              loading={
                initiateResetCharger.isLoading && selectedType === 'Hard'
              }
            >
              Hard
            </Button>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <Button
              type="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                setSelectedType('Soft');
                resetCharger('Soft');
              }}
              loading={
                initiateResetCharger.isLoading && selectedType === 'Soft'
              }
            >
              Soft
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  }

  /* Clear Cache */
  const initiateClearCache = useClearCacheMutation();
  async function clearCache() {
    try {
      const result = await initiateClearCache
        .mutateAsync({ ChargerId: cpid })
        .then((res) => res.data);
      message.success(result?.status);
    } catch (error) {
      message.error(`${error?.message}`);
    }
  }

  return (
    <>
      <Spin tip="Loading..." spinning={isChargerLoading}>
        <Card style={{ border: '0px solid #e7e7e9', padding: 20 }}>
          {/* <Row gutter={[8, 8]}>
            <Col sm="4" md="4" lg="4">
              <ChargerDetailCard
                cp={cp}
                cpid={cpid}
                isChargerLoading={isChargerLoading}
              />
            </Col>
          </Row> */}
          <Row gutter={[8, 8]}>
            <Col sm="8" md="8" lg="8">
              {/* Charger Id */}
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Charger Id
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'ID')}
                  </Title>
                </Col>
              </Row>

              {/* <Divider style={{ marginTop: '8px', marginBottom: '8px' }} /> */}
              <Divider />
              {/* Charger Name */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>Name</Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'NAME')}
                  </Title>
                </Col>
              </Row>

              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

              {/* Charger Address */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Address
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'ADDRESS')} ( {get(cp, 'COORDS')} )
                  </Title>
                </Col>
              </Row>

              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

              {/* Charger Capacity */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Capacity
                  </Text>
                </Col>
                <Col span={12}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'ENERGY')} kW
                  </Title>
                </Col>
              </Row>

              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

              {/* Charger Type */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>Type</Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'IS_DC') === 1 ? 'DC' : 'AC'}
                  </Title>
                </Col>
              </Row>

              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

              {/* Charger Timing */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Open Timing
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, `TIMING`) === '00:00-23:59'
                      ? 'Always Open'
                      : get(cp, 'TIMING')}
                  </Title>
                </Col>
              </Row>

              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

              {/* Charger Tariff */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Tariff
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    ₹ {get(cp, 'BASE_KWH_COST')} /kW
                  </Title>
                </Col>
              </Row>
              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
              {/* SIM Number */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    SIM Card No.
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'SIM_CARD_NUMBER') || 'NA'}
                  </Title>
                </Col>
              </Row>
              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
              {/* Provider */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Provider
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'PROVIDER') || 'NA'}
                  </Title>
                </Col>
              </Row>
              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
              {/* Phone Number */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Phone No.
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'PHONE_NUMBER') || 'NA'}
                  </Title>
                </Col>
              </Row>
              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
              {/* Router ID */}
              <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Router Id
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'ROUTER_ID') || 'NA'}
                  </Title>
                </Col>
              </Row>
              <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
              {/* Contact Person */}
              {/* <Row gutter={8}>
                <Col span={10}>
                  <Text style={{ margin: '0px', fontSize: '16px' }}>
                    Contact Person
                  </Text>
                </Col>
                <Col span={14}>
                  <Title level={5} style={{ margin: '0px' }}>
                    {get(cp, 'DEAILS') || '-'}
                  </Title>
                </Col>
              </Row> */}
            </Col>
            <Col sm="4" md="4" lg="4">
              {/* QR CODE */}
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <QRCode value={getChargerIdForQR()} size={300} id="qr-code" />

                <Button
                  type="link"
                  style={{ marginTop: '10px', cursor: 'pointer' }}
                  icon={
                    <DownloadOutlined
                      style={{
                        fontSize: '16px',
                        cursor: 'pointer',
                      }}
                    />
                  }
                  size="small"
                  onClick={() => downloadQR()}
                >
                  Download QR
                </Button>
                <div style={{ marginTop: '20px' }}>
                  <Button
                    type="primary"
                    size="large"
                    style={{ marginRight: '2px' }}
                    icon={<ClearOutlined />}
                    onClick={() => clearCache()}
                    loading={initiateClearCache.isLoading}
                  >
                    Clear Cache
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    icon={
                      <BiReset
                        style={{
                          marginBottom: '2px',
                          color: 'white',
                          marginRight: '5px',
                        }}
                      />
                    }
                    onClick={() => setResetChargermodalOpen(true)}
                  >
                    Reset Charger
                  </Button>
                  <ResetChargerModal
                    cpid={cpid}
                    isModalVisible={resetChargerModalOpen}
                    changeIsModalVisible={setResetChargermodalOpen}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </Spin>
      <div style={{ marginTop: 50 }}>
        <Connectors connectors={get(cp, 'CONNECTORS')} cpid={cpid} />
      </div>
      <div style={{ marginTop: 50 }}>
        <CorporateChargingQueue
          cpid={cpid}
          corporateId={corporateId}
          chargerId={get(cp, 'ID')}
        />
      </div>
      <div style={{ marginTop: 50 }}>
        <CorporateChargingSessionsGrid CPID={cpid} showAll />
      </div>
      {/* <ChargerControls cpid={cpid} /> */}

      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <Title level={4}>Connectors</Title>
      </div>

      <Spin tip="Loading..." spinning={isChargerLoading}>
        <Row style={{ border: '1px solid #e7e7e9' }}>
          <Col span={24}>
            <Connectors connectors={get(cp, 'CONNECTORS')} cpid={cpid} />
          </Col>
        </Row>
      </Spin> */}

      {/* <Tabs
        defaultActiveKey="1"
        onChange={(key) => setSessionsLogsSectionActivekey(key)}
        style={{ marginTop: '25px', marginBottom: '25px' }}
        tabBarExtraContent={
          sessionsLogsSectionActiveKey === '2' ? (
            <Select
              defaultValue={ocppLogsRefreshInterval}
              style={{ width: 120 }}
              onChange={(val) => {
                setOcppLogsRefreshInterval(val);
              }}
            >
              <Option value={3000}>3 seconds</Option>
              <Option value={5000}>5 seconds</Option>
              <Option value={10000}>10 seconds</Option>
            </Select>
          ) : null
        }
      >
        <TabPane tab="Charging Sessions" key="1">
          <CorporateChargingSessionsGrid CPID={cpid} />
        </TabPane>
        <TabPane tab="OCPP Logs" key="2">
          <OCPPLogs
            cpid={cpid}
            ocppLogsRefreshInterval={ocppLogsRefreshInterval}
            setOCPPLogsRefreshInterval={setOcppLogsRefreshInterval}
          />
        </TabPane>
        <TabPane tab="Connection History" key="3">
          <OCPPConnectionHistory
            cpid={cpid}
            ocppLogsRefreshInterval={ocppLogsRefreshInterval}
            setOCPPLogsRefreshInterval={setOcppLogsRefreshInterval}
          />
        </TabPane>
      </Tabs> */}
    </>
  );
}
